import styled from 'styled-components';

import { ExpandableContent } from 'components/expandable-content';

export const PaymentLabel = styled.p`
  margin: 0.75rem 0;
`;

export const AddCardTitle = styled.span`
  font-size: 0.8125rem;
  font-weight: normal;
`;

export const PaymentSection = styled.div<{ ref?: React.RefObject<HTMLDivElement> }>`
  width: 100%;
  max-width: 480px;
  margin: 2rem auto 0;
  padding: 0 1rem;

  ${Styles.desktop`
   padding: 0;
  `}
`;

export const DisclaimerWrapper = styled.p`
  color: ${Styles.color.grey.one};
  font-family: ${Styles.fontFamily.body};
  font-size: 0.75rem;
  margin: 2rem 0 0 0;
  padding: 0 0.25rem;
`;

export const PaymentInfoBackground = styled.div<{ $hostedPayment?: boolean }>`
  ${Styles.desktop`
    background-color: ${Styles.color.cardBackground};
    border-radius: ${Styles.borderRadius};
  `}
  ${props => props.$hostedPayment && `margin-top: 1.375rem;`}
`;

export const CartPriceTooLow = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  padding: 0.5rem;
  color: ${Styles.color.alert.warning.background};
  border: 2px solid ${Styles.color.alert.warning.background};
  margin: 1rem 0 0;
`;

export const AddMoreText = styled.span`
  font-weight: ${Styles.fontWeight.heavy};
  padding: 0 0 0 0.25rem;
`;
export const DisclaimerCardOfferInvalid = styled.div`
  text-align: center;
  padding: 1rem;
`;

export const DisclaimerCatering = styled.p`
  font-size: 0.75rem;
  font-style: italic;
  text-align: center;
`;

export const ErrorContainer = styled.div`
  margin-top: 1rem;
  background-color: #fae7ea;
  text-align: center;
`;

export const ErrorMessage = styled.p`
  margin: 0 2rem;
  padding: 0.7rem 0;
  color: ${Styles.color.primary};
`;

export const AddInlineGiftCardWrapper = styled.div`
  margin-top: 1rem;
`;

export const StyledIconCreditCard = styled.div`
  && {
    width: 2.125rem;
    max-width: 2.125rem;
    height: 1.5rem;
    margin: 0 0.25rem;
  }
`;

export const ExpandableContentTitle = styled.div`
  display: flex;
  align-items: center;
  font-weight: normal;
  font-family: ${Styles.fontFamily.base};
  font-size: 0.8125rem;
`;

export const CreditCardFormInputsWrapper = styled.div`
  padding: 1rem;
  ${Styles.desktop`
    padding: 0;`}
`;

export const StyledExpandableContent = styled(ExpandableContent)`
  button > div > svg {
    height: 0.75rem;
    fill: ${Styles.color.black};
  }
`;

export const SignUpToContinueDisclaimer = styled.p`
  color: ${Styles.color.grey.one};
  font-size: 0.85rem;
  font-weight: ${Styles.fontWeight.normal};
  text-align: center;
  margin-bottom: 2rem;
`;

export const WarningContainer = styled.div`
  padding: 1.5rem 0 0;
`;
